<span
  #dropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
  data-cy="date-range-picker:dropdown-trigger"
>
  @if (variant === 'button') {
    <rt-button
      variant="outline"
      [dropdownOpened]="dropdownOpen"
      [tabIndex]="tabIndex()"
      [disabled]="disabled()"
      (click)="!disabled() && !readOnly() && toggleDropdown(true)"
    >
      <div layout layout-align-items-center layout-full-width>
        <rt-icon name="calendar-today" />
        <rt-truncate>{{ selectedValueLabel || placeholder() }}</rt-truncate>
      </div>
    </rt-button>
  }

  @if (variant === 'input') {
    <rt-input
      variant="rounded"
      [readOnly]="true"
      [tabIndex]="tabIndex()"
      [disabled]="disabled()"
      [hasDropdownIndicator]="true"
      [class.dropdownOpened]="dropdownOpen"
      [placeholder]="placeholder()"
      [value]="selectedValueLabel"
      (click)="!disabled() && !readOnly() && toggleDropdown(true)"
    />
  }

  @if (variant === 'input-rounded' || variant === 'button-default') {
    <rt-button
      variant="tertiary"
      [tabIndex]="tabIndex()"
      [disabled]="disabled()"
      [dropdownOpened]="dropdownOpen"
      [class.input-rounded]="variant === 'input-rounded'"
      (click)="!disabled() && !readOnly() && toggleDropdown(true)"
    >
      <div layout layout-align-items-center layout-full-width>
        <rt-icon name="calendar-today" />
        <rt-truncate>{{ selectedValueLabel || placeholder() }}</rt-truncate>
      </div>
    </rt-button>
  }
</span>

<ng-template
  #dropdownOverlay="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="dropdownTrigger"
  [rtConnectedOverlayPosition]="dropdownPosition()"
  [open]="dropdownOpen"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown
    (click)="$event.stopPropagation()"
    class="dropdown"
    margin-bottom-small-xx
    [width]="
      showCustomDateRangePicker
        ? DropdownWidth.LargeXXXXX
        : horizontalDropdown()
          ? DropdownWidth.Large
          : DropdownWidth.SmallX
    "
  >
    <rt-dropdown-header [fullWidthTitle]="!showCustomDateRangePicker">
      {{ label() || ('app.common.custom_date' | translate) }}
      @if (showCustomDateRangePicker) {
        <rt-icon-button
          (click)="handleGoBackClick()"
          variant="plain"
          size="small"
          shape="square"
          iconName="arrow-back"
          prefix
        />
      }
    </rt-dropdown-header>

    @if (showCustomDateRangePicker) {
      <div [style.width]="'100%'" layout-centered padding-bottom-small-x padding-top-small>
        <rt-date-picker
          [mode]="'range'"
          [months]="2"
          [blackout]="blackout()"
          [direction]="customRangeDirection()"
          [value]="rangeValue"
          (valueChange)="handleCustomDateRangeChange($any($event))"
        />
      </div>
    }

    @if (!showCustomDateRangePicker) {
      <div [class.two-column]="horizontalDropdown()">
        @for (type of possibleDateRanges(); track trackByPossibleDateRange($index, type)) {
          <rt-dropdown-item
            (click)="
              handleDateRangeTypeChange(type);
              type === 'custom' ? $event.stopPropagation() : undefined
            "
            [class.full-width]="type === 'custom' || type === 'all_time' || type === 'range'"
          >
            {{ type | rtDateRangePickerLabel }}
          </rt-dropdown-item>
        }
      </div>
    }
    @if (addClearOption() && value() && value().type) {
      <rt-dropdown-item (click)="clear()" class="full-width">
        <rt-icon prefix name="clear" />
        {{ 'app.ui.date_range_picker.clear' | translate }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
